import { render } from "./FormCode.vue?vue&type=template&id=222590bc&scoped=true"
import script from "./FormCode.vue?vue&type=script&lang=js"
export * from "./FormCode.vue?vue&type=script&lang=js"

import "./FormCode.vue?vue&type=style&index=0&id=222590bc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222590bc"]])

export default __exports__